<template>
  <div class="system-settings-page">
    <div class="page-header">
      <h2>系统设置</h2>
      <el-button type="primary" :loading="saving" @click="handleSaveAll">保存修改</el-button>
    </div>

    <el-table
      v-loading="loading"
      :data="settings"
      border
      style="width: 100%"
    >
      <el-table-column prop="key" label="键名" min-width="180" />
      <el-table-column label="值" min-width="180">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value" />
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述" min-width="240" />
    </el-table>
  </div>
</template>

<script>
import {
  listSystemSettings,
  createSystemSetting,
  updateSystemSetting
} from "@/net/api";

const FIXED_SETTINGS = [
  {
    key: "story_typing_speed",
    value: "12",
    description: "故事播放器打字机速度（字/秒）"
  },
  {
    key: "story_continue_space",
    value: "-1",
    description: "对话自动播放速度（毫秒，-1 表示关闭自动播放）"
  },
  {
    key: "pic_max_width",
    value: "0",
    description: "图片最大宽度（像素，0 表示不限制）"
  },
  {
    key: "pic_max_height",
    value: "0",
    description: "图片最大高度（像素，0 表示不限制）"
  }
];

export default {
  name: "SystemSettings",
  data() {
    return {
      settings: [],
      loading: false,
      saving: false
    };
  },
  created() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      this.loading = true;
      try {
        const { data } = await listSystemSettings();
        const serverMap = new Map((data || []).map(item => [item.key, item]));
        this.settings = FIXED_SETTINGS.map(item => {
          const existing = serverMap.get(item.key) || {};
          return {
            key: item.key,
            value: existing.value != null ? String(existing.value) : item.value,
            description: item.description
          };
        });
      } catch (e) {
        this.$message.error("加载设置失败");
      } finally {
        this.loading = false;
      }
    },
    async handleSaveAll() {
      this.saving = true;
      try {
        for (const row of this.settings) {
          const payload = {
            value: String(row.value == null ? "" : row.value).trim(),
            description: row.description
          };
          try {
            await updateSystemSetting(row.key, payload);
          } catch (e) {
            if (e?.response?.status === 404) {
              await createSystemSetting({
                key: row.key,
                ...payload
              });
            } else {
              throw e;
            }
          }
        }
        this.$message.success("保存成功");
        await this.loadSettings();
      } catch (e) {
        this.$message.error("保存失败");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.system-settings-page {
  padding: 20px;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-header h2 {
  margin: 0;
}
</style>
